import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import DOMPurify from "dompurify";

const TermsAndConditions = () => {
  const [data, setData] = useState<string>("");

  const getData = async () => {
    const res = await fetch(process.env.PUBLIC_URL + "/static/terms.html");
    const data = await res.text();
    const page = DOMPurify.sanitize(data, {
      ALLOWED_TAGS: ["h1", "p", "span", "div", "li", "ul"],
      ALLOWED_ATTR: ["style"],
    });
    console.log(page);
    setData(page);
  };

  useEffect(() => {
    getData();
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Row>
        <Col span={16} offset={4}>
          <div dangerouslySetInnerHTML={{ __html: data }} />
        </Col>
      </Row>
    </>
  );
};

TermsAndConditions.displayName = "Terms and Conditions";

export default TermsAndConditions;
